import {
	RControl,
	RFeature,
	RFeatureUIEvent,
	RLayerTile,
	RLayerTileWebGL,
	RLayerVector,
	RMap,
	ROSM,
	ROSMWebGL,
	ROverlay,
	RStyle,
} from "rlayers"
import { RView } from "node_modules/rlayers/dist/RMap"
import { Coordinate } from "ol/coordinate"
import { OSMPointer, OSMPointerDragEndEvent } from "./Pointer"
import { Circle } from "ol/geom"
import "ol/ol.css"

interface OSMapComponentProps {
	view: React.ComponentProps<typeof RMap>["view"]
	initial: RView
	marker?: {
		coords: Coordinate
		onDragEnd: (event: OSMPointerDragEndEvent) => void
	}
	circleRadiusMeters?: number
}

const layersButton = (
	<div>
		<button type="button">&#9776;</button>
	</div>
)
export function OSMapComponent({
	view,
	initial,
	marker,
	circleRadiusMeters,
}: OSMapComponentProps) {
	return (
		<RMap view={view} width={"100%"} height={"100%"} initial={initial}>
			<RControl.RLayers
				element={layersButton}
				className="absolute right-0 top-0 flex flex-col justify-end items-end"
			>
				<ROSMWebGL properties={{ label: "Default osm" }} />
				<RLayerTileWebGL
					properties={{ label: "Maptiler hidpi" }}
					url="https://api.maptiler.com/maps/streets-v2/{z}/{x}/{y}@2x.png?key=GXxxYN7OjBPYoL7vc4hr"
				/>
				<RLayerTileWebGL
					properties={{ label: "Maptiler" }}
					url="https://api.maptiler.com/maps/streets-v2/{z}/{x}/{y}.png?key=GXxxYN7OjBPYoL7vc4hr"
				/>
			</RControl.RLayers>
			<RLayerVector>
				{marker && (
					<OSMPointer coords={marker.coords} onDragEnd={marker.onDragEnd} />
				)}
				{circleRadiusMeters && marker && (
					<CircleOverlay
						center={marker.coords}
						radiusMeters={circleRadiusMeters}
					/>
				)}
			</RLayerVector>
		</RMap>
	)
}

interface CircleOverlayProps {
	center: Coordinate
	radiusMeters: number
}

function CircleOverlay({ center, radiusMeters }: CircleOverlayProps) {
	return (
		<RFeature geometry={new Circle(center, radiusMeters)}>
			<RStyle.RStyle>
				<RStyle.RStroke color="#0973DC" width={2} />
				<RStyle.RFill color="rgba(0,0,255,0.1)" />
			</RStyle.RStyle>
		</RFeature>
	)
}
